'use client'

import { type Table } from '@tanstack/react-table'
import { Trash2 } from 'lucide-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import {
	DataTableActionBar,
	DataTableActionBarAction,
	DataTableActionBarSelection,
} from '@/components/data-table/data-table-action-bar'
import { Separator } from '@/components/ui/separator'
import { TaxExemptionItem } from '@/lib/api/taxExemptions'
import { BulkDeleteTaxExemptionsModal } from './bulk-delete-tax-exemptions-modal'

interface TaxExemptionsTableActionBarProps {
	table: Table<TaxExemptionItem>
}

export function TaxExemptionsTableActionBar({ table }: TaxExemptionsTableActionBarProps) {
	const { t } = useTranslation('taxes')
	const [showDeleteModal, setShowDeleteModal] = React.useState(false)
	const rows = table.getFilteredSelectedRowModel().rows

	const selectedIds = rows.map((r) => r.original.id)

	const handleDeleteSuccess = () => {
		table.resetRowSelection()
	}

	const handleDeleteClick = React.useCallback(() => {
		setShowDeleteModal(true)
	}, [])

	return (
		<>
			<DataTableActionBar table={table} visible={rows.length > 0}>
				<DataTableActionBarSelection table={table} />
				<Separator orientation="vertical" className="hidden data-[orientation=vertical]:h-5 sm:block" />
				<div className="flex items-center gap-1.5">
					<DataTableActionBarAction
						tooltip={t('deleteSelected')}
						onClick={handleDeleteClick}
						variant="destructive"
					>
						<Trash2 className="mr-2 h-4 w-4" />
						{t('deleteSelected')}
					</DataTableActionBarAction>
				</div>
			</DataTableActionBar>

			{showDeleteModal && (
				<BulkDeleteTaxExemptionsModal
					taxExemptionIds={selectedIds}
					onClose={() => setShowDeleteModal(false)}
					onSuccess={handleDeleteSuccess}
				/>
			)}
		</>
	)
}
